import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  useLocation,
} from 'react-router-dom';
import Home from '../../pages/home';
import profileStore from '../../objects/profile/store';
import Group from '../../pages/group';
import Category from '../../pages/category';
import Qrcode from '../../pages/qrcode';
import Complain from '../../pages/complain';
import Display from '../../pages/display';
import Search from '../../pages/search';
import Female from '../../pages/female';
import { ReactComponent as FindIcon } from '../icons/find.svg';
import { ReactComponent as FriendIcon } from '../icons/friend.svg';
import user from '../../objects/user/model';

console.log('profileStore', FindIcon);

const AppContent = observer(() => {
  const location = useLocation();
  console.log('location', location);
  if (user.info?.ban) {
    return <div>您访问的网页不存在</div>;
  }
  return (
    <>
      <Routes>
        <Route path="/" element={<Home></Home>}></Route>
        <Route path="/category/:id" element={<Category></Category>}></Route>
        <Route path="/group/:id" element={<Group></Group>}></Route>
        <Route path="/qrcode" element={<Qrcode></Qrcode>}></Route>
        <Route path="/complain" element={<Complain></Complain>}></Route>
        <Route path="/display" element={<Display></Display>}></Route>
        <Route path="/female" element={<Female></Female>}></Route>
        <Route path="/search" element={<Search></Search>}></Route>
      </Routes>
      {(location.pathname === '/' || location.pathname === '/display') && (
        <div className="fixed bottom-0 left-0 right-0 bg-white border-t flex justify-around items-center py-3 px-2">
          <NavLink
            to="/"
            className="flex flex-col items-center nav-icon active"
            style={({ isActive }) => ({
              color: isActive ? 'var(--adm-color-primary)' : '#666',
              textDecoration: 'none',
              fontWeight: isActive ? 'bold' : 'normal',
            })}
          >
            <FindIcon className="text-orange-500 text-xl"></FindIcon>
            <span className="text-xs mt-1 text-orange-500">发现</span>
          </NavLink>
          <NavLink
            to="/display"
            className="flex flex-col items-center nav-icon text-gray-500"
            style={({ isActive }) => ({
              color: isActive ? 'var(--adm-color-primary)' : '#666',
              textDecoration: 'none',
              fontWeight: isActive ? 'bold' : 'normal',
            })}
          >
            <FriendIcon className="text-xl"></FriendIcon>
            <span className="text-xs mt-1">聊友展示</span>
          </NavLink>
        </div>
      )}
    </>
  );
});

const App = observer(() => {
  useEffect(() => {
    console.log('effect', window.location);
    if (window.location.pathname !== '/login') {
      //   profileStore.queryUser();
    }

    // navigator.mediaDevices
    //   .getUserMedia({ video: true, audio: true })
    //   .then((localStream: MediaStream) => {
    //     alert('media');
    //   })
    //   .catch((error) => {
    //     alert('Error accessing media devices.');
    //     console.error('Error accessing media devices.', error);
    //   });
  }, []);
  return (
    <div className="app-container">
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </div>
  );
});

export default App;
